import { AttachmentResponse } from './attachment-response.model';

export class SubmittalModel {
  constructor(
    public submittalId: string,
    public documentTypeId: string,
    public publicationId: string,
    public commentsDueDate: string,
    public reviewRequestId: [],
    public attachments: Array<AttachmentResponse>,
    public intake: boolean,
    public publish: boolean,
    public determinationId: [],
    public actionDate: string,
    public projectId: string,
    public withdrawn: boolean,
    public comment: string,
    public analystId: string,
    public projectName: string,
    public eeaNo: string) { }
}
